import { Nav } from '../../../Shared/components-v2/nav/Nav';
import { useProcessNavTransition } from '../../hooks/useProcessNavTransition';
import { NavLink } from '../nav-link/NavLink';

export const SettingsNav = () => {
  const processNavTransition = useProcessNavTransition();

  return (
    <>
      <Nav.Separator />
      <Nav aria-label="Settings">
        <Nav.List>
          <Nav.ListItem key="settings">
            <NavLink to="/settings" onClick={processNavTransition}>
              <NavLink.Icon name="Gear" />
              <NavLink.Text>Settings</NavLink.Text>
            </NavLink>
          </Nav.ListItem>
          <Nav.ListItem key="log out">
            <NavLink to="/login?logout=true" rel="nofollow" data-method="delete" reloadDocument={true}>
              <NavLink.Icon name="Power" />
              <NavLink.Text>Log out</NavLink.Text>
            </NavLink>
          </Nav.ListItem>
        </Nav.List>
      </Nav>
    </>
  );
};
